import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { API_URL } from '../../config/config';

// Define a service using a base URL and expected endpoints
export const eventApi = createApi({
  reducerPath: 'eventReducerApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_URL}/`,
    //  prepareHeaders: (headers) => {

    //     headers.set('Access-Control-Allow-Origin', 'https://api-dev.equinebreeders.com/api/User/v2/');
    //     headers.set('Access-Control-Allow-Credentials', 'include');
    //     headers.set('Access-Control-Allow-Methods', 'GET, POST, PUT,PATCH, DELETE, OPTIONS');
    //     headers.set('Content-Type', 'application/json');

    //     console.log(headers);
    //     return headers;
    //   },
    prepareHeaders: (headers, { getState }) => {
      const states = getState()

      const token = states.auth.token
      headers.set('authorization', `Bearer ${token}`);
      return headers
    },
    credentials: 'include', // This allows server to set cookies

  }),
  tagTypes: ['eventList'],
  endpoints: (builder) => ({
    getEvents: builder.query({
      query: (page, size) => {
        return {
          url: `Event/index?orderBy=Id&orderByDesc=true&page=${page}&size=${10}`,
          method: 'GET',
        }
      },
      providesTags: ['eventList'],
    }),
    createEvent: builder.mutation({
      query: (event) => {
        return {
          url: 'Event/create',
          method: 'POST',
          body: {
            id: 0,
            name: event,
            horseIds: [],
            addHorses: true
          }
        }
      },
      invalidatesTags: ['eventList'],
    }),
    updateEvent: builder.mutation({
      query: (event) => {
        // console.log('eee', event);
        return {
          url: `Event/edit/${event?.id}`,
          method: 'PUT',
          body: { id: event.id, name: event.name }
        }
      },
      invalidatesTags: ['eventList'],
    }),


  }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetEventsQuery, useCreateEventMutation, useUpdateEventMutation } = eventApi